import React from 'react';
import { Box } from '@mui/material';
import { CustomButtonFieldSx } from './utils/customSx';
import { DeleteButton } from './buttons/DeleteButton';
import { UploadButton } from './buttons/UploadButton';
import { DownloadButton } from './buttons/DownloadButton';
import { ReloadButton } from './buttons/ReloadButton';

export const FileBrowserButtons: React.FC = () => {
  return (
    <Box component="div" sx={CustomButtonFieldSx}>
      <Box component="div" sx={{ width: '100%' }}>
        <UploadButton />
      </Box>
      <Box component="div" sx={{ width: '100%' }}>
        <DownloadButton />
      </Box>
      <Box component="div" sx={{ width: '100%' }}>
        <DeleteButton />
      </Box>
      <Box component="div" sx={{ width: '100%' }}>
        <ReloadButton />
      </Box >
    </Box>
  );
};
